import { DateTime } from 'luxon';
import { DateZone, Position } from '@oai-frontend-monorepo/types';
import parseExpirationFromLeg from './parseExpirationFromLeg';
import { shortDays } from '../market-information/mapHolidays';

export const isPositionExpired = (
  position?: Position,
  addHours = 0,
  isSPX = false
) => {
  if (!position?.legPositions || !position?.strategyName) {
    return false;
  }

  const expiryString = parseExpirationFromLeg({
    legs: position.legPositions,
    strategy: position.strategyName,
  });

  if (!expiryString) {
    return false;
  }

  const expiryDateTime = DateTime.fromFormat(expiryString, 'yyMMdd');

  let _addHours = addHours;

  if (
    shortDays?.[expiryDateTime.toFormat('yyyy-MM-dd') as keyof typeof shortDays]
  ) {
    _addHours = -3;
  }

  const expiryDate = expiryDateTime
    .setZone(DateZone.New_York)
    .startOf('day')
    .plus({ hour: 16 + _addHours });

  return (
    expiryDate.plus({ minute: 1 + (isSPX ? 15 : 0) }) <
    DateTime.utc().setZone(DateZone.New_York)
  );
};
